import { Box, Container, Heading } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import Layout from "scenes/layouts";
import LogosTable from "components/table";
import LogosTablePagination from "components/table/table-pagination";
import PartnerService from "services/partners/partner-service";
import { useNavigate } from "react-router-dom";
import { usePaginator } from "chakra-paginator";
import LoadingScreen from "components/loading-screen";

const ListPartnerScene = (): ReactElement => {
    const navigate = useNavigate();
    const [partners, setPartners] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [totalPartner, setTotalPartner] = useState<number>(0);

    const {
        pagesQuantity,
        currentPage,
        setCurrentPage,
        pageSize,
        setPageSize,
        offset
    } = usePaginator({
        total: totalPartner,
        initialState: {
            pageSize: 20,
            currentPage: 1
        }
    });

    useEffect(() => {
        setIsLoading(true);
        let skipCount = ((currentPage - 1) * pageSize);

        PartnerService.GetPartners("", skipCount, pageSize).then((res: any) => {
            if (res.result) {
                setPartners(res.result.items);
                setTotalPartner(res.result.totalCount);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, [currentPage]);

    const handleClickRow = (partner: any) => {
        window.open(`/partners/${partner.id}`);
    };

    const handlePageChange = (nextPage: number) => {
        setCurrentPage(nextPage);
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Mitra</Heading>
                </Box>
                <Box mt={6}>
                    <LogosTable
                        headers={[{ label: 'Nama' }, { label: 'Partner Id' }, { label: 'Tanggal Bergabung' }, { label: "Aktif Sampai" }, { label: 'Saldo', isNumeric: true }, { label: 'Status' }]}
                        rows={[{ propertyName: 'user.fullName', baseUrl: '/partners/' }, { propertyName: 'partnerId' }, { propertyName: 'creationTime', isDate: true }, { propertyName: 'validTo', isDate: true }, { propertyName: 'balance', isNumeric: true }, { propertyName: 'statusString' }]}
                        data={partners}
                        onRowClick={handleClickRow}
                    />
                    <LogosTablePagination currentPage={currentPage} pagesQuantity={pagesQuantity} handlePageChange={handlePageChange} />
                </Box>
            </Container>
        </Layout>
    );
};

export default ListPartnerScene;